module.exports = __webpack_public_path__ + "static/media/oumar.1f4167dc.jpeg";